import React, { useEffect, useState } from "react";

/**
 * Entrance loader — shown once per session.
 * Types "DRIJESH PPATEL" then slides up, revealing the site.
 */
export default function Loader() {
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return true;
    return !sessionStorage.getItem("dp_loader_seen");
  });
  const [typed, setTyped] = useState("");
  const [out, setOut] = useState(false);
  const [progress, setProgress] = useState(0);
  const target = "Dr. Drijesh Ppatel";

  useEffect(() => {
    if (!show) return;
    document.documentElement.classList.add("loading");

    let i = 0;
    const typeInt = setInterval(() => {
      i += 1;
      setTyped(target.slice(0, i));
      if (i >= target.length) clearInterval(typeInt);
    }, 85);

    let p = 0;
    const barInt = setInterval(() => {
      p += 1.4 + Math.random() * 2.5;
      if (p >= 100) {
        p = 100;
        clearInterval(barInt);
      }
      setProgress(p);
    }, 45);

    const outT = setTimeout(() => setOut(true), 3200);
    const gone = setTimeout(() => {
      setShow(false);
      document.documentElement.classList.remove("loading");
      try { sessionStorage.setItem("dp_loader_seen", "1"); } catch {}
    }, 4100);

    return () => {
      clearInterval(typeInt);
      clearInterval(barInt);
      clearTimeout(outT);
      clearTimeout(gone);
      document.documentElement.classList.remove("loading");
    };
  }, [show]);

  if (!show) return null;

  return (
    <div className={`loader ${out ? "out" : ""}`}>
      <div>
        <div style={{ opacity: 0.55 }}>[ Index · 2026 ]</div>
        <div style={{ marginTop: 6 }}>Engineering Leader · GenAI · Cyber</div>
      </div>
      <div className="loader-center">
        <div className="loader-name">
          {typed}
          <span className="cursor" />
        </div>
      </div>
      <div style={{ textAlign: "right" }}>
        <div style={{ opacity: 0.55 }}>Loading portfolio</div>
        <div style={{ marginTop: 6 }}>{String(Math.floor(progress)).padStart(3, "0")} / 100</div>
      </div>
      <div className="loader-bar" style={{ "--p": progress / 100 }} />
    </div>
  );
}
